import { checkKYC } from '@/api/user';
import { Button, Text } from '@/components/common';
import { ImgWrapper, InnerWrapper } from '@/components/common/Loading/LoadingStyled';
import { NOT_ACTIVE, PENDING, REJECTED, VERIFIED } from '@/components/common/Sidebar/constant';
import { FormLabel, FormMarginDense, FormWrapper } from '@/components/form';
import KYCElement from '@/components/page/Identity/KycElement';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { Box } from '@mui/material';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { KYCLayout } from '../../container/KYCLayout';
import { useOnfido } from '../../hook/useOnfido';
import { ContentWrapper } from './styles';

const VerifyIdentity: any = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userInfo = useAppSelector((state: any) => get(state, 'user.userInfo'));
  const [, , , nextStep] = useOnfido(userInfo?.id);
  const dispatch = useAppDispatch();
  const [mounted, setMounted] = useState(false);

  const userKYC = useAppSelector((state: any) => get(state, 'user.userKYCResult'));

  useEffect(() => {
    dispatch({ type: 'HIDE_LOADING' });

    const checkKycPassed = async () => {
      const kycPassed = await checkKYC(dispatch, userInfo.id);
      if (kycPassed) {
        navigate('/insurance-declaration');
      }
      setMounted(true);
      return;
    };
    checkKycPassed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const KycElementData = [
    {
      ico: 'home',
      content: t('HOME_ADDRESS'),
      status: userKYC?.personalDetails.hasStarted && userKYC?.personalDetails.hasEnded ? VERIFIED : NOT_ACTIVE,
    },
    {
      ico: 'selfie',
      content: t('FACIAL_VERIFICATION'),
      status: userKYC?.identity.hasStarted && userKYC?.identity.hasEnded ? VERIFIED : NOT_ACTIVE,
    },
    {
      ico: 'licence',
      content: t('DRIVING_LICENCE'),
      status: userKYC?.licence.hasStarted && userKYC?.licence.hasEnded ? VERIFIED : NOT_ACTIVE,
    },
  ];

  const handleSubmit = async () => {
    dispatch({ type: 'SHOW_LOADING' });
    await nextStep(0);
  };

  if (!mounted)
    return (
      <Box sx={{ height: '500px' }}>
        <InnerWrapper>
          <ImgWrapper src="/images/logo/circle-logo-white.png" alt="Indicator" fetchPriority={'high'} />
        </InnerWrapper>
      </Box>
    );

  const verifiedStep = KycElementData?.filter((item) => item.status === VERIFIED);
  const stillRequiredStep = KycElementData?.filter((item) => item.status === NOT_ACTIVE || item.status === PENDING);
  const rejectedStep = KycElementData?.filter((item) => item.status === REJECTED);

  return (
    <FormWrapper>
      <div id="onfido-mount"></div>
      <Text color="darkPrimary" variant="title">
        Hi <span className="fs-mask">{`${userInfo?.licence?.first_name ?? userInfo?.first_name ?? ''}`}</span>
      </Text>
      <Text variant="content" color="darkSecondary">
        {t('VERIFY_IDENTITY_SUBTITLE')}
      </Text>
      <ContentWrapper>
        <div>
          {verifiedStep.length === 0 ? (
            <>
              <FormMarginDense>
                <Text color="darkPrimary" size="18">
                  {t('REQUIRED')}
                </Text>
              </FormMarginDense>
              <FormMarginDense value="8">
                {KycElementData.map((item, index) => {
                  return <KYCElement key={index} isLast={index === KycElementData.length - 1} {...item} />;
                })}
              </FormMarginDense>
            </>
          ) : (
            <>
              {verifiedStep && verifiedStep.length ? (
                <>
                  <FormMarginDense>
                    <FormLabel text={t('VERIFIED')} />
                  </FormMarginDense>
                  <FormMarginDense value="8">
                    {verifiedStep.map((item, index) => {
                      return <KYCElement key={index} isLast={index === verifiedStep.length - 1} {...item} />;
                    })}
                  </FormMarginDense>
                </>
              ) : null}
              {stillRequiredStep && stillRequiredStep.length ? (
                <>
                  <FormMarginDense>
                    <FormLabel text={t('STILL_REQUIRED')} />
                  </FormMarginDense>
                  <FormMarginDense value="8">
                    {stillRequiredStep.map((item, index) => {
                      return (
                        <KYCElement
                          key={index}
                          isLast={index === stillRequiredStep.length - 1}
                          {...item}
                          status={PENDING}
                        />
                      );
                    })}
                  </FormMarginDense>
                </>
              ) : null}
              {rejectedStep.length ? (
                <>
                  <FormMarginDense>
                    <FormLabel text={t('REJECTED')} />
                  </FormMarginDense>
                  <FormMarginDense value="8">
                    {rejectedStep.map((item, index) => {
                      return <KYCElement key={index} isLast={index === rejectedStep.length - 1} {...item} />;
                    })}
                  </FormMarginDense>
                </>
              ) : null}
            </>
          )}
        </div>
        {
          <Box sx={{ mt: { xxl: 8, lg: 6, xxs: 5 } }}>
            <Button fullWidth variant="contained" color="white" type="submit" onClick={handleSubmit}>
              {t('CONTINUE')}
            </Button>
          </Box>
        }
      </ContentWrapper>
    </FormWrapper>
  );
};

VerifyIdentity.getLayout = KYCLayout;
export default VerifyIdentity;
